import { useState } from "react";

/**
 * Khung ảnh của màn Hướng dẫn Concept — xoay theo hướng của chính tấm ảnh.
 *
 * Bộ ảnh hướng dẫn ảnh thẻ: 36/45 tấm là ảnh dọc 4x6, 7 tấm còn lại là sơ đồ
 * cắt ảnh và bảng thông số visa nằm ngang. Một khung cố định luôn xén hỏng một
 * trong hai nhóm (khung ngang cũ cắt mất đầu và vai của mọi ảnh thẻ), nên khung
 * chạy theo ảnh: dọc → 4x6, ngang → 6x4. CEO chốt 29/08/2026.
 *
 * `object-contain`: ảnh đúng tỉ lệ 2:3 lấp đầy khung y hệt cover, còn vài tấm
 * lệch tỉ lệ (3x4, bảng visa gần vuông) giữ nguyên chữ thay vì bị xén mất.
 *
 * Mặc định coi là ảnh dọc cho tới khi tải xong — đa số ảnh dọc nên bố cục ít
 * nhảy nhất.
 */
export function GuideThumb({
  src,
  long,
  className,
}: {
  src: string;
  /** Cạnh dài của khung (px). Cạnh ngắn = 2/3 cạnh này. */
  long: number;
  className?: string;
}) {
  const [landscape, setLandscape] = useState(false);
  const short = Math.round((long * 2) / 3);

  return (
    <img
      src={src}
      alt=""
      loading="lazy"
      data-testid="guide-thumb"
      width={landscape ? long : short}
      height={landscape ? short : long}
      onLoad={(e) => {
        const img = e.currentTarget;
        if (img.naturalWidth > 0)
          setLandscape(img.naturalWidth > img.naturalHeight);
      }}
      className={`block shrink-0 object-contain ${className ?? ""}`}
      style={{
        width: landscape ? long : short,
        height: landscape ? short : long,
      }}
    />
  );
}

/** Ô trống cùng cỡ khung dọc — dùng khi thẻ chưa có ảnh nào. */
export function GuideThumbEmpty({ long }: { long: number }) {
  return (
    <div
      className="shrink-0 rounded-md bg-muted/10"
      style={{ width: Math.round((long * 2) / 3), height: long }}
    />
  );
}
